module.exports = __webpack_public_path__ + "img/peoImg2.3918c026.png";